import { RoomFree } from "@/types/dashboard.type";
import { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export default function TableHeaderRoomFree(): ColumnDef<RoomFree>[] {
    const {t} = useTranslation();

    return [
        {
            header: t("dashboard.property_name"),
            accessorKey: "business_unit_name",
            enableSorting: false
        },
        {
            header: t("businessunit.room_number"),
            accessorKey: "code",
            enableSorting: false
        },
        {
            header: t("dashboard.room_type"),
            accessorKey: "name",
            enableSorting: false
        },
    ]
}
